import { render, staticRenderFns } from "./NewsV2.vue?vue&type=template&id=9d4c5e9a&scoped=true&"
import script from "./NewsV2.vue?vue&type=script&lang=js&"
export * from "./NewsV2.vue?vue&type=script&lang=js&"
import style0 from "./NewsV2.vue?vue&type=style&index=0&id=9d4c5e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4c5e9a",
  null
  
)

export default component.exports